import { ExamEditPage } from "@/features/learning-content/pages/ExamEdit";
import { Box, Stack } from "@mui/material";
import { FC } from "react";

const ExamEdit: FC = () => {
  return (
    <Stack sx={{ mt: 1 }}>
      <Box sx={{ mb: 2.5 }}>
        <ExamEditPage />
      </Box>
    </Stack>
  );
};

export default ExamEdit;
